import { useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { parse } from 'query-string'
import { batch, useDispatch } from 'react-redux'
import { setType } from 'features/dashboard/dashboardCommonSlice'
import { DashboardInfoTypes, DashboardTypes } from 'features/Codes'
import api from 'api/axios/foka'
import {
  setAdGroupId,
  setCampaignId,
  setCreativeLinkId,
  setKeywordId,
} from 'features/dashboard/filter/dashboardFilterSlice'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import { setInfo } from 'features/dashboard/info/dashboardInfoSlice'
import FullPageLoading from 'components/loading/FullPageLoading'
import { fail } from 'features/toast/Toast'

const DashboardIdRedirect = () => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const { search } = useLocation()
  const history = useHistory()
  const { campaignId, adGroupId, keywordId, creativeLinkId } = parse(search)

  useEffect(() => {
    ;(async () => {
      let errorMessage
      const campaignIds = []
      const adGroupIds = []
      if (campaignId) {
        await api.ad.getCampaign(campaignId).catch(() => {
          errorMessage = '삭제된 캠페인 입니다.'
        })
      } else if (adGroupId) {
        await api.ad
          .getAdGroup(adGroupId)
          .then(({ data: { adGroupDto } }) => {
            campaignIds.push(adGroupDto.campaignId)
          })
          .catch(() => {
            errorMessage = '삭제된 광고그룹 입니다.'
          })
      } else if (keywordId) {
        await api.ad
          .getKeyword(keywordId)
          .then(({ data: { keywordDto } }) => {
            campaignIds.push(keywordDto.campaignId)
            adGroupIds.push(keywordDto.adGroupId)
          })
          .catch(() => {
            errorMessage = '삭제된 키워드 입니다.'
          })
      } else if (creativeLinkId) {
        await api.ad
          .getCreativeLink(creativeLinkId)
          .then(({ data: { creativeLinkDto } }) => {
            campaignIds.push(creativeLinkDto.campaignId)
            adGroupIds.push(creativeLinkDto.adGroupId)
          })
          .catch(() => {
            errorMessage = '삭제된 소재 입니다.'
          })
      }
      if (errorMessage) {
        fail(errorMessage)
        batch(() => {
          dispatch(setType(DashboardTypes.CAMPAIGN))
          dispatch(campaignTableActions.setPage(0))
        })
      } else {
        batch(() => {
          dispatch(campaignTableActions.setSelectedIds(campaignIds))
          dispatch(campaignTableActions.setPage(0))
          dispatch(adGroupTableActions.setSelectedIds(adGroupIds))
          dispatch(adGroupTableActions.setPage(0))
          dispatch(keywordTableActions.setSelectedIds([]))
          dispatch(keywordTableActions.setPage(0))
          dispatch(creativeTableActions.setSelectedIds([]))
          dispatch(creativeTableActions.setPage(0))
          if (creativeLinkId) {
            dispatch(
              setInfo({ type: DashboardInfoTypes.CREATIVE, id: creativeLinkId })
            )
            dispatch(setCreativeLinkId(creativeLinkId))
            dispatch(setType(DashboardTypes.CREATIVE))
          } else if (keywordId) {
            dispatch(
              setInfo({ type: DashboardInfoTypes.KEYWORD, id: keywordId })
            )
            dispatch(setKeywordId(keywordId))
            dispatch(setType(DashboardTypes.KEYWORD))
          } else if (adGroupId) {
            dispatch(
              setInfo({ type: DashboardInfoTypes.AD_GROUP, id: adGroupId })
            )
            dispatch(setAdGroupId(adGroupId))
            dispatch(setType(DashboardTypes.AD_GROUP))
          } else if (campaignId) {
            dispatch(
              setInfo({ type: DashboardInfoTypes.CAMPAIGN, id: campaignId })
            )
            dispatch(setCampaignId(campaignId))
            dispatch(setType(DashboardTypes.CAMPAIGN))
          }
        })
      }
      history.replace(`/${adAccountId}/dashboard`)
    })()
  }, [
    dispatch,
    campaignId,
    adGroupId,
    keywordId,
    creativeLinkId,
    adAccountId,
    history,
  ])
  return <FullPageLoading />
}
export default DashboardIdRedirect
